import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import moment from 'moment';
import 'moment-duration-format';
import { UserModel } from '../../app/modules/auth/models/UserModel';
import { CustomField } from '../../interfaces/Settings';
import { addNumberFormatting, createSingleOptionWorksheets, exportWorkbook, setColumnWidths, styleColumns } from './helperTemplateExcel';
import { addWorkSheetInfo } from './helperTemplateExcel';
import { createWorksheet } from './helperTemplateExcel';
import { createWorkbook } from './helperTemplateExcel';
import { MultiSimplePipeline, SimplePipeline } from '../../interfaces/Pipeline';
import { MultiSimpleMerchant, SimpleMerchant } from '../../interfaces/Merchant';
import { MultiSimpleMeeting, SimpleMeeting } from '../../interfaces/Meeting';
import { User } from '../../interfaces/User';
import { addSingleOptionValidation } from './functionHelperExcel';
interface ExportTemplateMerchantExcelProps {
    nameFile: string,
    customFields: CustomField,
    source: string,
    typeAction: string,
    settings: any,
    nameInfo: string,
    nameHeader: any,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    simpleCustomFieldsMaster: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
        users: Record<string, User[]>;
    },
    user: UserModel,
    param: any,
    intl: any,
    type?: string,
}

export const exportTemplateMerchantExcel = async ({ nameFile, customFields, source, typeAction, settings, nameInfo, nameHeader, setIsLoading, simpleCustomFieldsMaster, user, param, type, intl }: ExportTemplateMerchantExcelProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet1");
    const worksheetInfo = createWorksheet(workbook, "Info");
    var header: string[] = []
    var subHeader: string[] = []
    let singleOptionSheetsMerchants = {};

    header = [...nameHeader.insert.merchant.header];
    subHeader = [...nameHeader.insert.merchant.subHeader];

    let worksheetUser = workbook.addWorksheet('Daftar PIC');
    await worksheetUser.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetUser.getCell('A1').value = `Daftar PIC`;
    await param.dataUsers.forEach((user: any) => {
        worksheetUser.addRow([user.name]);
    });

    let worksheetCity = workbook.addWorksheet('Daftar Kota');
    await worksheetCity.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetCity.getCell('A1').value = `Daftar Kota`;
    await param.dataCities.forEach((user: any) => {
        worksheetCity.addRow([user.name]);
    });

    // Daftar Single Option
    singleOptionSheetsMerchants = createSingleOptionWorksheets({ customFields, workbook, simpleCustomFieldsMaster, user, intl });

    // kalau type nya error akan menambahkan kolom di bawah ini
    if (type === 'error') {
        header.push('Error');
        subHeader.push('Abaikan kolom ini');
        Array.from(param.listErrorInsert).map((row: any, index) => {
            var temp_excel = [];
            temp_excel.push(
                row.name,
                row.pic_name,
                row.city_name,
                row.phone,
                row.email,
                ...Object.keys(customFields).map((field: any) => row[field])
            );

            // Menambahkan row.error di akhir
            temp_excel.push(row.error);
            exportData.push(temp_excel);
        });
    }

    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader;
    setColumnWidths(worksheet, source, header!, exportData);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);
    addDataRows(worksheet, exportData, customFields, source, type!, typeAction, user!, param, singleOptionSheetsMerchants, simpleCustomFieldsMaster);
    addWorkSheetInfo(worksheetInfo, source, nameFile, nameInfo, nameHeader, user!);

    exportWorkbook(workbook, worksheet, source, `${nameFile}.xlsx`, setIsLoading);
};

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
    customFields: CustomField,
    source: string,
    type: string,
    typeAction: string,
    user: UserModel,
    param?: any,
    singleOptionSheets?: any,
    simpleCustomFieldsMaster?: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
    }
) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });

    for (let i = 3; i < 550; i++) {
        if (typeAction === 'insert') {
            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar PIC'!$A$2:$A$${param.dataUsers.length + 1}`],
                errorStyle: 'error',
                error: 'Pilih PIC',
            };

            if (user?.data.company_id !== 'd2f2a3da-3829-4872-8891-cae921d555b5') {
                worksheet.getCell('C' + i).dataValidation = {
                    type: 'list',
                    allowBlank: false,
                    showErrorMessage: true,
                    formulae: [`='Daftar Kota'!$A$2:$A$${param.dataCities.length + 1}`],
                    errorStyle: 'error',
                    error: 'Pilih kota',
                };
            }

            addSingleOptionValidation('F', customFields, singleOptionSheets, typeAction, type, param, worksheet, simpleCustomFieldsMaster);
            addNumberFormatting('F', customFields, typeAction, type, param, worksheet);
        }
    }
};
